import { createSlice } from '@reduxjs/toolkit';
import { Notification } from 'components/CustomNotification';
import {
  AddComment,
  GetCommentById,
  AddCommentsReply,
  DeleteCommentsReply,
} from '../services/CommentService';

export const CommentSlice = createSlice({
  name: 'dropdown',
  initialState: {
    addComment: '',
    CommentList: [],
    getComment: '',
    addCommentReply: '',
  },
  reducers: {
    addComment: (state, action) => {
      state.addComment = [action.payload];
    },
    CommentList: (state, action) => {
      state.CommentList = [action.payload];
    },
    getComment: (state, action) => {
      state.getComment = [action.payload];
    },
    addCommentReply: (state, action) => {
      state.addCommentReply = [action.payload];
    },
  },
});

export const AddCommentList = (payload, type) => async (dispatch) => {
  AddComment(payload, type)
    .then((response) => {
      dispatch(addComment(response));
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
    });
};

export const addCommentsReply = (payload) => async (dispatch) => {
  AddCommentsReply(payload)
    .then((response) => {
      dispatch(addCommentReply(response));
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
    });
};

export const getCommentBypostId =
  (data, currentTime, page, size, userId) => async (dispatch) => {
    return GetCommentById(data, currentTime, page, size, userId)
      .then((response) => {
        dispatch(getComment(response.data));
        return response.data;
      })
      .catch((err) => {
        Notification('warning', err.response?.data?.message);
        return err.response?.data?.message;
      });
  };

export const deleteCommentsReply = (id, type) => async () => {
  return DeleteCommentsReply(id, type);
};

export const { CommentList, getComment, addComment, addCommentReply } =
  CommentSlice.actions;
export default CommentSlice.reducer;
